import { useEffect } from "react"
import { useState } from "react"
import { MdErrorOutline } from "react-icons/md"
import { useNavigate, useParams } from "react-router-dom"
import Spinner from "../../Components/Spinner"
import { createNewUser } from "../../Requests/firebaseAuth"
import { createUserDoc, getInviteDoc, updateInviteStatus } from "../../Requests/firebaseFirestore"
import { setOrganizerContact } from "../../Requests/sendMail"

export default function NewOrganizerPage(){
  const {inviteId} = useParams()
  const [invite, setInvite] = useState({})
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(true)
  const [newUser, setNewUser] = useState({})
  const [sending, setSending] = useState(false)
  const [authError, setAuthError] = useState('')
  const navigate = useNavigate()


  const getInfo = async () =>{
    setLoading(true)
    const invt = await getInviteDoc(inviteId)
    if(invt){
      if(invt.status==='accepted'){
        setError(true)
      }
      setInvite(invt)
    }else{
      setError(true)
    }
    setLoading(false)
  }

  const handleSignInSubmit = async (e) =>{
    e.preventDefault()
    setSending(true)
    if(newUser.password === newUser.repeatPassword){
      const res = await createNewUser(invite.email, newUser.password)
      if(res.status === 'success'){
        await createUserDoc({
          uid:res.user.uid,
          fullName:invite.name,
          company:'Mediaware',
          email:invite.email,
          role:'organizer',
          type:'admin',
          events:[]
        })
        await setOrganizerContact(invite.email)
        await updateInviteStatus(inviteId)
        navigate('/')
      }else{
        switch (res.error.code) {
          case 'auth/weak-password':
            setAuthError('La contraseña debe tener más de 6 caracteres')
            break;
            default:
              setAuthError('Ha ocurrido un error desconocido, por favor intente más tarde')
              break;
            }
          }
    }else{
      setAuthError('Las contraseñas ingresadas son diferentes')
    }
    setSending(false)
  }

  const handleInputChange=(e)=>{
    setAuthError('')
    const {name, value} = e.target
    setNewUser({...newUser, [name]:value})
  }

  useEffect(()=>{
    getInfo()
  },[])

  return(<>
  {loading?<div><Spinner/></div>:
    <div className="bg-white rounded-[10px] py-4 px-3 w-1/2 max-w-[500px] mx-auto flex flex-col justify-center items-center">
    
    {error?
    <>
    <div className="bg-white rounded-[10px] py-4 px-3 w-1/2 max-w-[500px] mx-auto flex flex-col justify-center items-center">
        <span className="text-[#F03623]"><MdErrorOutline size={150}/></span>
        <span className="text-center">La invitación ya no es válida</span>
      </div>
    </>:<>
    <h1 className="text-2xl text-[#392C75] font-semibold text-center my-4">Crear cuenta de organizador</h1>
    {authError!==''?
      <div className="w-[75%] py-2 px-3 border rounded-[10px] border-[#EE2325] text-[#EE2325] text-center  mb-4">
        <span>{authError}</span>
      </div>:<></>}
    <form onSubmit={handleSignInSubmit} className='flex flex-col gap-4 w-full'>
      <div className="input-holder w-[75%]">
        <input type="text" name="fullName" id="new-user-name" onChange={handleInputChange} value={invite.name} readOnly/>
        <label htmlFor="new-user-name">Nombre completo</label>
      </div>
      <div className="input-holder w-[75%]">
        <input type="email" name="email" id="new-user-email" onChange={handleInputChange} value={invite.email} readOnly/>
        <label htmlFor="new-user-email">Email</label>
      </div>
      <div className="input-holder w-[75%]">
        <input type="password" name="password" id="new-user-password" onChange={handleInputChange} value={newUser.password||''} required/>
        <label htmlFor="new-user-password">Contraseña</label>
      </div>
      <div className="input-holder w-[75%]">
        <input type="password" name="repeatPassword" id="new-user-repeat-password" onChange={handleInputChange} value={newUser.repeatPassword||''} required/>
        <label htmlFor="new-user-repeat-password">Repetir contraseña</label>
      </div>
      <button className="send-btn" disabled={sending}>{sending?'Creando':'Crear cuenta'}</button>
    </form>
    </>}

    </div>}</>
  )
}